<template>
  <div class="product-detail-container">
    <!-- <div class="product-detail-header">
      <button @click="backToList" class="back-button">← 返回列表</button>
    </div> -->
    <div class="product-detail-content">
      <!-- 左侧：图片区域 -->
      <div class="product-images-section">
        <!-- 桌面端：垂直滚动图片 -->
        <div class="image-scroll-container desktop-image-container">
          <!-- 主图 -->
          <img v-if="productDetail && productDetail.coverImg" :src="productDetail.coverImg" alt="商品主图" class="detail-image"/>

          <!-- 桌面端：产品信息卡片：展示产品特性和规格参数 -->
          <ProductInfoCard 
            :specifications="productSpecifications"
            class="product-info-card-wrapper desktop-product-info-card"
          />
          <!-- 商品介绍图 -->
          <div class="desktop-detail-section">
            <div class="section-header desktop-detail-header">
              <span class="header-text">图文详情</span>
            </div>
            <div class="desktop-detail-content">
              <img v-for="(img, index) in (productDetail && productDetail.imgList || [])" :key="index" :src="img" alt="商品介绍图"
                  class="detail-image desktop-detail-image"/>
            </div>
          </div>
        </div>

        <!-- 移动端：封面图 -->
        <div class="mobile-cover-image-container mobile-image-container">
          <img v-if="productDetail && productDetail.coverImg" :src="productDetail.coverImg" alt="商品封面图" class="mobile-cover-image"/>
        </div>
      </div>

      <!-- 右侧：商品信息区域 -->
      <div class="product-detail-info">
        <h2 class="product-title">{{ productDetail ? productDetail.title : '' }}</h2>
        <div class="product-description">
          <p v-html="productDetail ? (productDetail.detailHtml || '暂无描述') : ''"></p>
        </div>

        <div class="product-price-section">
          <div class="product-price">
            <span class="price-unit">¥</span>
            <span class="price">
              {{ currentSkuPrice }}
            </span>
            <span v-if="productDetail && productDetail.marketPrice" class="market-price">¥{{ productDetail.marketPrice }}</span>
          </div>
          <div class="product-stock">库存: {{ currentSkuStock }}件</div>
        </div>

        <div class="sku-selection">
          <h4>规格选择:</h4>
          <div v-if="specifications && specifications.length > 0" class="specs-selector">
            <div v-for="(specGroup, index) in specifications" :key="index" class="spec-group">
              <h5>{{ specGroup.name }}</h5>
              <div class="spec-options">
                <button
                  v-for="(option, optionIndex) in specGroup.options"
                  :key="optionIndex"
                  :disabled="!isSpecCombinationValid(specGroup.name, option) && !isSpecSelected(specGroup.name, option)"
                  :class="['spec-option',
                           { active: isSpecSelected(specGroup.name, option) },
                           { disabled: !isSpecCombinationValid(specGroup.name, option) && !isSpecSelected(specGroup.name, option) }]"
                  @click="selectSpec(specGroup.name, option)">
                  {{ option }}
                </button>
              </div>
            </div>
          </div>
          <div v-else class="original-sku-selection">
            <el-radio-group v-model="selectedSkuId">
              <el-radio v-for="sku in (productDetail && productDetail.skuList || [])" :key="sku.skuId" :label="sku.skuId"
                        @change="updateSelectedSku(sku)">
                <span v-if="typeof sku.specs === 'string' && isJsonString(sku.specs)">
                  {{ formatSpecs(JSON.parse(sku.specs)) }}
                </span>
                <span v-else>
                  {{ sku.specs || '默认规格' }}
                </span>
              </el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="quantity-selection">
          <h4>数量:</h4>
          <el-input-number v-model="quantity" :min="currentSkuMin" :max="currentSkuStock" @change="updateQuantity"/>
        </div>
        <!-- 总价和购买按钮同一行 -->
        <div v-if="canPurchase" class="purchase-section">
          <div class="total-price">
            总价: <span class="total-price-amount">¥{{ totalPrice }}</span>
          </div>
          <div class="payment-buttons">
            <button type="button" class="weui-btn purchase-button weui-btn_primary"
                    :disabled="!canPurchase" @click="goToOrderConfirm">
              立即购买
            </button>
          </div>
        </div>
      </div>

      <!-- 移动端：产品信息卡片：展示产品特性和规格参数 -->
      <ProductInfoCard 
        :specifications="productSpecifications"
        class="product-info-card-wrapper mobile-product-info-card"
      />

      <!-- 移动端：商品介绍图 -->
      <div class="mobile-detail-images-container mobile-image-container">
        <div class="section-header detail-header">
          <span class="header-text">图文详情</span>
        </div>
        <div class="detail-images-content">
          <img v-for="(img, index) in (productDetail && productDetail.imgList || [])" :key="index" :src="img" alt="商品介绍图"
               class="mobile-detail-image"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 商品详情页面组件
 * 业务背景：展示单个商品的详细信息，包括图片、规格选择、价格计算等，用户可在此页面选择规格和数量后进入订单确认
 * 设计决策：将商品详情独立为单独页面，通过路由参数传递商品ID，提升页面可维护性和用户体验
 */
import {shopRequest} from "@/utils/utils";
import ProductInfoCard from "@/components/ProductInfoCard.vue";

export default {
  name: "ProductDetail",
  components: {
    ProductInfoCard
  },
  data() {
    return {
      productDetail: null, // 商品详情数据
      selectedSkuId: null, // 选中的SKU ID
      selectedSpecs: {}, // 记录选中的规格
      specifications: [], // 规格维度数组
      quantity: 1, // 购买数量
      //产品规格参数列表
      productSpecifications: [
        { name: "尺寸", value: "13cm*11cm*13cm, 2.3kg" },
        { name: "载玻片格式", value: "26mm*76mm*0.9mm~1.2mm（含盖玻片）" },
        { name: "图像传感器", value: "160万像素全局曝光彩色CMOS传感器" },
        { name: "分辨率", value: "0.25µm/像素（20X）；0.16 µm/像素（40X）" },
        { name: "扫描模式", value: "面扫描" },
        { name: "扫描速度", value: "15mmX15mm 30秒（20X）" },
        { name: "聚焦", value: "自动聚焦" },
        { name: "多层扫描", value: "支持" },
        { name: "图像格式", value: "tiff/svs/bmp" },
        { name: "数据存储", value: "本地/云端存储" },
        { name: "供电电压", value: "12V" },
        { name: "功率", value: "约60W" },
        { name: "工作温度", value: "5°C~40°C" }
      ]
    };
  },

  computed: {
    /**
     * 计算当前选中SKU的库存
     * 业务背景：不同规格的商品可能有不同的库存，需要根据选中的SKU显示对应库存
     * 设计决策：优先使用SKU的库存，如果没有则使用商品默认库存，确保库存信息准确
     */
    currentSkuStock() {
      // 如果没有选中有效的SKU，返回商品默认库存
      if (!this.selectedSkuId || !this.productDetail || !this.productDetail.skuList) {
        return this.productDetail ? this.productDetail.stock : 0;
      }

      // 查找当前选中的SKU
      const selectedSku = this.productDetail.skuList.find(sku => sku.skuId === this.selectedSkuId);
      if (selectedSku && selectedSku.stock !== undefined) {
        return selectedSku.stock;
      }

      // 如果没有找到SKU或SKU没有特定库存，则返回商品默认库存
      return this.productDetail ? this.productDetail.stock : 0;
    },

    /**
     * 计算当前选中SKU的最小数量
     * 业务背景：确保用户至少选择1件商品
     * 设计决策：有选中SKU时最小值为1，否则为0，防止无效购买
     */
    currentSkuMin() {
      // 如果没有选中有效的SKU，最小值为0
      if (!this.selectedSkuId) {
        return 0;
      }
      // 否则最小值为1
      return 1;
    },

    /**
     * 计算当前选中SKU的价格
     * 业务背景：不同规格的商品可能有不同的价格，需要根据选中的SKU显示对应价格
     * 设计决策：优先使用SKU的价格，如果没有则使用商品默认价格，确保价格信息准确
     */
    currentSkuPrice() {
      // 如果没有选中有效的SKU，返回商品默认价格
      if (!this.selectedSkuId || !this.productDetail || !this.productDetail.skuList) {
        return this.productDetail ? this.productDetail.price : 0;
      }

      // 查找当前选中的SKU
      const selectedSku = this.productDetail.skuList.find(sku => sku.skuId === this.selectedSkuId);
      if (selectedSku && selectedSku.price !== undefined) {
        return selectedSku.price;
      }

      // 如果没有找到SKU或SKU没有特定价格，则返回商品默认价格
      return this.productDetail ? this.productDetail.price : 0;
    },

    /**
     * 计算总价
     * 业务背景：用户需要知道所选商品和数量的总价
     * 设计决策：单价乘以数量，保留两位小数，确保价格计算准确
     */
    totalPrice() {
      return (this.currentSkuPrice * this.quantity).toFixed(2);
    },

    /**
     * 检查是否可以购买
     * 业务背景：只有选择了有效SKU、规格完整、有库存且数量大于0时才能购买
     * 设计决策：综合判断多个条件，确保购买操作的合法性
     */
    canPurchase() {
      return this.selectedSkuId &&
        this.isCurrentSelectionComplete() &&
        this.currentSkuStock > 0 &&
        this.quantity > 0;
    },

    /**
     * 合并所有商品图片用于轮播图
     * 业务背景：移动端需要使用轮播图展示商品图片，需要将主图和介绍图合并
     * 设计决策：将 coverImg 和 imgList 合并成一个数组，确保主图在前，方便用户查看
     */
    allImages() {
      if (!this.productDetail) return [];
      const images = [];
      // 添加主图
      if (this.productDetail.coverImg) {
        images.push(this.productDetail.coverImg);
      }
      // 添加介绍图
      if (this.productDetail.imgList && Array.isArray(this.productDetail.imgList)) {
        images.push(...this.productDetail.imgList);
      }
      return images;
    }
  },

  watch: {
    /**
     * 监听选中SKU的变化
     * 业务背景：当用户切换规格时，需要自动调整数量，确保不超过库存
     * 设计决策：在SKU变化时自动校验并调整数量，提升用户体验
     */
    selectedSkuId: {
      handler(newVal) {
        // 当选中的SKU发生变化时
        if (newVal) {
          // 如果有选中的SKU
          const selectedSku = this.productDetail.skuList.find(sku => sku.skuId === newVal);
          if (selectedSku) {
            if (this.quantity > selectedSku.stock) {
              this.quantity = selectedSku.stock;
            }
            if (this.quantity === 0) {
              this.quantity = 1;
            }
          }
        } else {
          // 如果没有选中的SKU
          this.quantity = 0;
        }
      },
      immediate: true
    }
  },

  /**
   * 组件创建时根据路由参数获取商品详情
   * 业务背景：页面加载时需要根据商品ID获取对应的商品详情数据
   * 设计决策：从路由参数中获取商品ID，异步加载数据，避免阻塞页面渲染
   */
  async created() {
    const productId = this.$route.params.productId;
    if (productId) {
      await this.loadProductDetail(productId);
    } else {
      this.$message.error('商品ID不存在');
      this.backToList();
    }
  },

  methods: {
    /**
     * 加载商品详情数据
     * 业务背景：需要从服务器获取商品的完整信息，包括SKU列表、规格等
     * 设计决策：使用独立的API请求方法，提取规格维度，初始化默认选中项
     * @param {string|number} productId - 商品ID
     */
    async loadProductDetail(productId) {
      try {
        const response = await shopRequest('get', '/getProductDetail', { productId: productId });
        this.productDetail = response;
        this.extractSpecifications(); // 提取规格维度
        this.selectedSkuId = this.productDetail.skuList && this.productDetail.skuList.length > 0 
          ? this.productDetail.skuList[0].skuId 
          : null;
        this.quantity = 1;

        // 初始化选中规格
        if (this.productDetail.skuList && this.productDetail.skuList.length > 0) {
          const firstSku = this.productDetail.skuList[0];
          if (firstSku.specs && this.isJsonString(firstSku.specs)) {
            const specsObj = JSON.parse(firstSku.specs);
            this.selectedSpecs = {...specsObj};
            this.$forceUpdate(); // 强制更新视图
          }
        }
      } catch (error) {
        console.error('获取商品详情失败:', error);
        this.$message.error('获取商品详情失败');
        this.backToList();
      }
    },

    /**
     * 提取规格维度
     * 业务背景：需要从SKU列表中提取所有可能的规格组合，用于规格选择器
     * 设计决策：遍历所有SKU，收集每个规格维度的所有选项，转换为数组格式便于渲染
     */
    extractSpecifications() {
      if (!this.productDetail || !this.productDetail.skuList) return;

      const specDimensions = {}; // 用于存储每个维度的所有选项

      // 遍历所有SKU，提取规格维度
      this.productDetail.skuList.forEach(sku => {
        if (sku.specs && this.isJsonString(sku.specs)) {
          const specsObj = JSON.parse(sku.specs);
          Object.keys(specsObj).forEach(key => {
            if (!specDimensions[key]) {
              specDimensions[key] = new Set();
            }
            specDimensions[key].add(specsObj[key]);
          });
        }
      });

      // 转换为数组格式
      this.specifications = Object.keys(specDimensions).map(key => ({
        name: key,
        options: Array.from(specDimensions[key])
      }));

      this.$forceUpdate(); // 强制更新视图
    },

    /**
     * 判断是否为JSON字符串
     * 业务背景：SKU的规格可能是JSON字符串格式，需要判断并解析
     * 设计决策：使用try-catch安全地判断字符串是否为有效JSON，避免解析错误
     * @param {string} str - 待判断的字符串
     * @returns {boolean} - 是否为JSON字符串
     */
    isJsonString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },

    /**
     * 格式化规格显示
     * 业务背景：规格对象需要转换为可读的字符串格式显示给用户
     * 设计决策：将对象键值对转换为"key:value"格式，多个规格用空格分隔
     * @param {Object|string} specs - 规格对象或字符串
     * @returns {string} - 格式化后的规格字符串
     */
    formatSpecs(specs) {
      if (typeof specs === 'object' && specs !== null) {
        return Object.entries(specs).map(([key, value]) => `${key}:${value}`).join(' ');
      }
      return specs || '默认规格';
    },

    /**
     * 判断规格是否被选中
     * 业务背景：规格选择器需要高亮显示已选中的规格
     * 设计决策：比较当前规格名称和选项是否与已选规格匹配
     * @param {string} specName - 规格名称
     * @param {string} option - 规格选项
     * @returns {boolean} - 是否被选中
     */
    isSpecSelected(specName, option) {
      return this.selectedSpecs && this.selectedSpecs[specName] === option;
    },

    /**
     * 判断规格组合是否有效
     * 业务背景：不是所有规格组合都有对应的SKU，需要禁用无效组合
     * 设计决策：创建临时规格对象，检查是否存在匹配的SKU，避免用户选择无效组合
     * @param {string} specName - 规格名称
     * @param {string} option - 规格选项
     * @returns {boolean} - 规格组合是否有效
     */
    isSpecCombinationValid(specName, option) {
      // 创建一个临时的规格选择对象
      const tempSpecs = {...this.selectedSpecs, [specName]: option};

      // 检查是否存在匹配的SKU
      return this.productDetail.skuList.some(sku => {
        if (sku.specs && this.isJsonString(sku.specs)) {
          const specsObj = JSON.parse(sku.specs);
          // 检查是否所有已选择的规格都匹配
          return Object.keys(tempSpecs).every(key =>
            specsObj[key] === tempSpecs[key]
          );
        }
        return false;
      });
    },

    /**
     * 检查当前规格选择是否完整
     * 业务背景：只有选择了完整且有效的规格组合才能购买
     * 设计决策：检查是否存在完全匹配的SKU，确保规格选择的有效性
     * @returns {boolean} - 规格选择是否完整
     */
    isCurrentSelectionComplete() {
      if (!this.selectedSpecs || Object.keys(this.selectedSpecs).length === 0) {
        return false;
      }
      // 查找完全匹配的SKU
      return this.productDetail.skuList.some(sku => {
        if (sku.specs && this.isJsonString(sku.specs)) {
          const specsObj = JSON.parse(sku.specs);
          // 检查是否所有选中的规格都匹配
          return Object.keys(this.selectedSpecs).every(key =>
            specsObj[key] === this.selectedSpecs[key]
          );
        }
        return false;
      });
    },

    /**
     * 选择规格
     * 业务背景：用户点击规格选项时需要更新选中状态并找到对应的SKU
     * 设计决策：更新选中规格后查找匹配的SKU，自动调整数量，提升用户体验
     * @param {string} specName - 规格名称
     * @param {string} option - 规格选项
     */
    selectSpec(specName, option) {
      // 更新选中规格
      this.$set(this.selectedSpecs, specName, option);

      // 查找匹配的SKU
      const matchedSku = this.findMatchingSku();

      // 如果找到匹配的SKU，则更新选中的SKU ID
      if (matchedSku) {
        this.selectedSkuId = matchedSku.skuId;
        // 确保数量在有效范围内
        this.$nextTick(() => {
          if (this.quantity > matchedSku.stock) {
            this.quantity = matchedSku.stock;
          }
          if (this.quantity === 0 && matchedSku.stock > 0) {
            this.quantity = 1;
          }
        });
      } else {
        // 如果没有匹配的SKU，清空selectedSkuId并将数量设置为0
        this.selectedSkuId = null;
        this.$nextTick(() => {
          this.quantity = 0;
        });
      }
    },

    /**
     * 查找匹配的SKU
     * 业务背景：根据选中的规格组合找到对应的SKU
     * 设计决策：优先查找完全匹配的SKU，如果没有则尝试部分匹配，确保能找到合适的SKU
     * @returns {Object|null} - 匹配的SKU对象或null
     */
    findMatchingSku() {
      if (!this.productDetail || !this.productDetail.skuList) return null;

      // 查找完全匹配的SKU
      const exactMatch = this.productDetail.skuList.find(sku => {
        if (sku.specs && this.isJsonString(sku.specs)) {
          const specsObj = JSON.parse(sku.specs);
          // 检查是否所有选中的规格都匹配
          return Object.keys(this.selectedSpecs).every(key =>
            specsObj[key] === this.selectedSpecs[key]
          );
        }
        return false;
      });

      if (exactMatch) {
        return exactMatch;
      }

      // 如果没有完全匹配的，尝试部分匹配（优先级较低）
      return this.productDetail.skuList.find(sku => {
        if (sku.specs && this.isJsonString(sku.specs)) {
          const specsObj = JSON.parse(sku.specs);
          // 只要有一个规格匹配即可
          return Object.keys(this.selectedSpecs).some(key =>
            specsObj[key] === this.selectedSpecs[key]
          );
        }
        return false;
      });
    },

    /**
     * 返回商品列表页面
     * 业务背景：用户点击返回按钮时需要回到商品列表
     * 设计决策：使用路由跳转而不是组件状态切换，保持页面独立性
     */
    backToList() {
      this.$router.push({
        name: 'ProductList'
      });
    },

    /**
     * 更新选中的SKU
     * 业务背景：当使用单选按钮选择SKU时，需要同步更新规格选择状态
     * 设计决策：从SKU的规格信息中提取并更新selectedSpecs，保持数据一致性
     * @param {Object} sku - SKU对象
     */
    updateSelectedSku(sku) {
      this.selectedSkuId = sku.skuId;

      // 同步更新selectedSpecs
      if (sku.specs && this.isJsonString(sku.specs)) {
        const specsObj = JSON.parse(sku.specs);
        this.selectedSpecs = {...specsObj};
        this.$forceUpdate(); // 强制更新视图
      }
    },

    /**
     * 更新数量
     * 业务背景：用户修改购买数量时需要更新数据
     * 设计决策：简单的数据更新方法，保持代码清晰
     * @param {number} value - 新的数量值
     */
    updateQuantity(value) {
      this.quantity = value;
    },

    /**
     * 组合订单确认页所需的商品数据并写入 sessionStorage
     * 业务背景：订单确认页刷新后会丢失路由参数，需通过缓存保持用户已选的商品信息
     * 设计决策：使用 sessionStorage 在同一会话内暂存数据，既能避免敏感信息长期存放，又能覆盖刷新场景
     * @returns {Object} - 包含商品详情、SKU 编号与数量的载荷对象
     */
    prepareOrderConfirmPayload() {
      const payload = {
        productDetail: this.productDetail,
        selectedSkuId: this.selectedSkuId,
        quantity: this.quantity
      };
      sessionStorage.setItem('orderConfirmProductData', JSON.stringify(payload));
      return payload;
    },

    /**
     * 跳转到订单确认页面
     * 业务背景：用户点击立即购买时需要进入订单确认页，但需要先验证购买条件
     * 设计决策：在跳转前进行完整的购买条件检查，提供明确的错误提示，确保数据有效性
     */
    goToOrderConfirm() {
      // 检查是否可以购买
      if (!this.canPurchase) {
        if (!this.selectedSkuId) {
          this.$message.error('请选择有效的商品规格');
        } else if (!this.isCurrentSelectionComplete()) {
          this.$message.error('请选择完整的规格');
        } else if (this.currentSkuStock <= 0) {
          this.$message.error('该规格商品库存不足');
        } else if (this.quantity <= 0) {
          this.$message.error('请选择购买数量');
        }
        return;
      }

      // 传递商品信息到订单确认页面
      const productPayload = this.prepareOrderConfirmPayload();
      this.$router.push({
        name: 'OrderConfirm',
        params: { productData: productPayload }
      });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  text-align: left;
}

div {
  display: block;
  box-sizing: border-box;
}

img {
  border: 0;
  vertical-align: top;
  display: inline-block;
}

button {
  -webkit-appearance: button;
  appearance: button;
  text-rendering: auto;
  color: buttontext;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0;
  text-shadow: none;
  display: inline-block;
  text-align: center;
  align-items: flex-start;
  cursor: default;
  background-color: buttonface;
  box-sizing: border-box;
  margin: 0;
  font: 400 13.3333px Arial;
  padding: 1px 6px;
  border-width: 2px;
  border-style: outset;
  border-color: buttonface;
  border-image: initial;
}

button, input, optgroup, select, textarea {
  margin: 0;
  padding: 0;
  border: 1px solid #ededed;
  border-radius: 0;
  font-family: Hiragino Sans GB, Microsoft Yahei, SimSun, Arial, Helvetica Neue, Helvetica;
}

/* 商品详情样式 */
.product-detail-container {
  padding: 20px;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
}

/* 网页端版心设置 - 占屏幕80%宽度 */
@media (min-width: 769px) {
  .product-detail-container {
    width: 80%;
    max-width: 100%;
    margin: 0 auto;
    padding: 40px 60px;
  }
}

.product-detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.back-button {
  margin-right: 15px;
  padding: 8px 16px;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #666;
  cursor: pointer;
  font-size: 14px;
}

.product-detail-content {
  display: flex;
  gap: 20px;
}

/* 图片区域容器 */
.product-images-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 产品信息卡片包装器样式 */
.product-info-card-wrapper {
  width: 100%;
  margin-top: 20px;
}

/* 桌面端显示，移动端隐藏 */
.desktop-product-info-card {
  display: block;
}

/* 移动端显示，桌面端隐藏 */
.mobile-product-info-card {
  display: none;
}

.image-scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80vh;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.detail-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
  margin-bottom: 15px;
}

.detail-image:last-child {
  margin-bottom: 0;
}

.product-detail-info {
  flex: 1;
  padding: 20px;
  /* background: #f5f7fa; */
  border-radius: 4px;
  position: sticky;
  max-width: 40%;
  margin-left: 20px;
}

.product-description {
  margin-bottom: 20px;
  color: #666;
  line-height: 1.6;
}

.product-price-section {
  margin-bottom: 20px;
}

.product-price {
  font-size: 24px;
  font-weight: bold;
  color: #ff7452;
}

.market-price {
  margin-left: 10px;
  font-size: 18px;
  color: #999;
  text-decoration: line-through;
}

/* 购买区域：总价和按钮同一行 */
.purchase-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
  padding-top: 15px;
  border-top: 1px solid #ddd;
  gap: 20px;
}

.total-price {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  flex: 1;
}

.total-price-amount {
  color: #ff7452;
  font-size: 22px;
}

.product-stock {
  margin: 10px 0;
  color: #666;
  font-size: 14px;
}

.sku-selection {
  margin-bottom: 20px;
}

.sku-selection h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #333;
}

.quantity-selection {
  margin-bottom: 20px;
}

.quantity-selection h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #333;
}

.payment-buttons .purchase-button:disabled {
  background-color: #f5f7fa;
  border-color: #dcdfe6;
  color: #c0c4cc;
  cursor: not-allowed;
}

.payment-buttons .purchase-button:not(:disabled) {
  background-color: #7b9d38;
  border-color: #7b9d38;
  color: #fff;
}

.payment-buttons .purchase-button:not(:disabled):hover {
  background-color: #6a8a2f;
  border-color: #6a8a2f;
}

.purchase-button {
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 4px;
  white-space: nowrap; /* 防止按钮文字换行 */
}

.payment-buttons {
  margin: 0;
  flex-shrink: 0; /* 按钮不收缩 */
}

.specs-selector .spec-group {
  margin-bottom: 15px;
}

.specs-selector .spec-group h5 {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #666;
}

.specs-selector .spec-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.specs-selector .spec-option {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  font-size: 14px;
  transition: all 0.3s;
}

.specs-selector .spec-option:hover {
  border-color: #409eff;
}

.specs-selector .spec-option.active {
  border-color: #409eff;
  background: #ecf5ff;
  color: #409eff;
  font-weight: bold;
}

.original-sku-selection {
  margin-top: 10px;
}

.specs-selector .spec-option.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  border-style: dashed;
}

.specs-selector .spec-option.disabled:hover {
  border-color: #dcdfe6;
}

.product-title {
  margin-bottom: 20px;
}

/* 轮播图容器样式 */
.image-carousel-container {
  width: 100%;
  margin-bottom: 20px;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Element UI 轮播图样式优化 */
.image-carousel-container .el-carousel {
  border-radius: 8px;
  overflow: hidden;
}

.image-carousel-container .el-carousel__item {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
}

.image-carousel-container .el-carousel__indicators {
  bottom: 10px;
}

.image-carousel-container .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  border: none;
}

.image-carousel-container .el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

/* 默认：桌面端显示垂直滚动，移动端隐藏 */
.desktop-image-container {
  display: block;
}

.mobile-image-container {
  display: none;
}

/* 移动端封面图容器 */
.mobile-cover-image-container {
  width: 100%;
  margin-bottom: 15px;
}

.mobile-cover-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  border-radius: 4px;
}

/* 移动端商品介绍图容器 */
.mobile-detail-images-container {
  width: 100%;
  margin-top: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* 桌面端图文详情区域 - 与产品信息卡片样式一致 */
.desktop-detail-section {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 20px 0;
}

/* 图文详情标题样式 - 与规格参数标题一致 */
.section-header {
  padding: 12px 20px;
  background: #7b9d38;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}

.header-text {
  display: inline-block;
}

/* 桌面端图文详情内容区域 */
.desktop-detail-content {
  padding: 20px;
}

/* 桌面端图文详情中的图片样式 */
.desktop-detail-content .detail-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
  margin-bottom: 15px;
}

.desktop-detail-content .detail-image:last-child {
  margin-bottom: 0;
}

/* 移动端图文详情内容区域 */
.detail-images-content {
  padding: 20px;
}

.mobile-detail-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  border-radius: 4px;
  margin-bottom: 15px;
}

.mobile-detail-image:last-child {
  margin-bottom: 0;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .product-detail-container {
    padding: 10px;
  }

  .product-detail-content {
    flex-direction: column;
    gap: 15px;
    display: flex;
  }

  .product-images-section {
    width: 100%;
  }

  /* 移动端隐藏桌面端的垂直滚动容器和商品介绍图 */
  .desktop-image-container {
    display: none;
  }

  /* 移动端隐藏桌面端图文详情区域 */
  .desktop-detail-section {
    display: none;
  }

  .desktop-detail-image {
    display: none;
  }

  /* 移动端隐藏桌面端的产品信息卡片 */
  .desktop-product-info-card {
    display: none;
  }

  /* 移动端显示封面图 */
  .mobile-cover-image-container {
    display: block;
    order: 1;
  }

  /* 移动端显示商品信息区域 */
  .product-detail-info {
    order: 2;
  }

  /* 移动端显示产品信息卡片 */
  .mobile-product-info-card {
    display: block;
    margin-top: 20px;
    order: 3;
  }

  /* 移动端显示商品介绍图 */
  .mobile-detail-images-container {
    display: block;
    order: 4;
    border-radius: 4px;
  }

  /* 移动端图文详情标题样式 */
  .section-header {
    padding: 10px 15px;
    font-size: 14px;
  }

  /* 移动端图文详情内容区域 */
  .detail-images-content {
    padding: 15px;
  }

  .product-detail-info {
    max-width: 100%;
    margin-left: 0;
    position: static;
    padding: 15px;
  }

  .product-title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .product-price {
    font-size: 20px;
  }

  .market-price {
    font-size: 16px;
  }

  /* 移动端购买区域：总价和按钮同一行 */
  .purchase-section {
    flex-direction: row;
    align-items: center;
    gap: 15px;
  }

  .total-price {
    font-size: 16px;
    text-align: left;
    flex: 1;
  }

  .total-price-amount {
    font-size: 20px;
  }

  .payment-buttons {
    width: auto;
    flex-shrink: 0;
  }

  .sku-selection h4,
  .quantity-selection h4 {
    font-size: 15px;
  }

  .specs-selector .spec-option {
    padding: 8px 12px;
    font-size: 13px;
  }

  .purchase-button {
    padding: 14px 24px;
    font-size: 16px;
    white-space: nowrap; /* 防止按钮文字换行 */
  }
}
</style>

